export default {
	name: 'UserSettings',
	options: {
		schema: 'users',
		table: 'user_setting_lookup'
	}
};
